export enum XRRequestTrackingState {
  None,
  Submitted,
  Resolved,
  Rejected,
  Destroyed,
  WaitingDestroy
}
